import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../api";
import { useAuth } from "./AuthContext";

const ConfigContext = createContext(null);

export function ConfigProvider({ children }) {
  const { user } = useAuth();
  const [config, setConfig] = useState(null);

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/config/bootstrap");
      setConfig(data);
    } catch (e) { /* handled by pages */ }
  }, []);

  useEffect(() => {
    if (user) reload();
    else setConfig(null);
  }, [user, reload]);

  return <ConfigContext.Provider value={{ config, reload }}>{children}</ConfigContext.Provider>;
}

export const useConfig = () => useContext(ConfigContext);
